module.exports = __webpack_public_path__ + "static/media/ChangEKitchenINTA0008_design_clean_v002.0fec010a.png";